





































import Vue from "vue";
import Component from "vue-class-component";
import { Photo } from "../../services/settings/entities/photo.interface";
import constants from "../../config/constants";

@Component
export default class extends Vue {
  private created(): void {
    this.$store.dispatch("settings/getPhotos");
  }

  private get photos(): Array<Photo> {
    const result = this.$store.getters["settings/getPhotos"].filter(
      (photo: Photo) => photo.photoType == constants.PHOTO_TYPE.CAROUSEL
    );
    return result;
  }
  getUrl(photo: Photo) {
    const url = `${photo.photoURL}${
      photo.photoURL.includes("?") ? "&" : "?"
    }autoplay=1&controls=0&loop=1`;
    return url;
  }
  isVideo(photo: Photo) {
    return photo.photoKind == constants.PHOTO_KIND.VIDEO;
  }
}
